// extracted by mini-css-extract-plugin
module.exports = {"userListContainer":"CampaignsList_userListContainer__1kylq","contentComponent":"CampaignsList_contentComponent__3_JW8"};